import { Component, Input, SimpleChanges } from '@angular/core';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-membership-deatails',
  imports: [TranslateModule, CommonModule],
  templateUrl: './membership-deatails.component.html',
  styleUrl: './membership-deatails.component.css'
})
export class MembershipDeatailsComponent {

  logs: any[] = [];
  showMembershipModal: boolean = false;
  membershipId: number = +localStorage.getItem("membershipId")!
  @Input() membershipData: any;


  ngOnChanges(changes: SimpleChanges) {
    if (changes['membershipData'] && this.membershipData) {
      // كل مرة يوصل فيها Input جديد
      this.logs = this.membershipData.logs;
    }
  }

  // getMembershipById() {
  //   this.MembershipService.getMemberShipById(this.membershipId).subscribe({
  //     next: (res: any) => {
  //       this.logs = res.value.logs;
  //       // console.log("this.previewUrls", this.previewUrls)
  //     }
  //   })
  // }

  closeMembershipModal() {
    this.showMembershipModal = false;

    // خزّن إنه قفل المودال
    localStorage.setItem('membershipModalClosed', 'true');

    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }

}
